import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';

export function createAlgoliaRedirectUrlPlugin(options: Record<string, any> = {}) {
  return createRedirectUrlPlugin({
    ...options,
  });
}
